import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class TopAnimation {
  constructor() {
    if (
      document.querySelector(".-top") &&
      window.matchMedia("(min-width: 1280px)").matches
    ) {
      this.initialize();
    }
  }

  initialize() {
    const navs = document.querySelectorAll(".p-nav1__list1 li");
    gsap.from(navs, {
      opacity: 0,
      y: -40,
      duration: 1,
      stagger: 0.05,
      ease: "Power3.easeOut",
    });

    const timeline1 = gsap.timeline();

    timeline1
      .from(".p-keyVisual1__catch1", {
        opacity: 0,
        x: -64,
        duration: 0.75,
        ease: "Power3.easeOut",
      })
      .from(
        ".p-keyVisual1__buttons1 li",
        {
          opacity: 0,
          y: 40,
          duration: 0.75,
          ease: "Power3.easeOut",
          stagger: 0.05,
        },
        "-=0.5"
      )
      .from(
        ".p-keyVisual1__image1",
        {
          opacity: 0,
          y: 40,
          duration: 1.5,
          ease: "Power3.easeOut",
        },
        "-=0.5"
      );

    const horizontal = [".p-feature1__list1 li"];

    horizontal.forEach(function (el) {
      gsap.from(el, {
        opacity: 0,
        x: -25,
        duration: 1.5,
        ease: "Expo.easeOut",
        stagger: 0.05,
        scrollTrigger: {
          trigger: el,
          start: "top+=200 bottom",
        },
      });
    });

    const vertical = [
      ".p-feature1__wrap1",
      ".p-newProjects1__title1",
      ".p-newProjects1__wrap1",
      ".p-newProjects1__button1",
      ".p-search1",
      ".p-company1__title1",
      ".p-company1__list1",
      ".p-company1__wrap2",
      ".p-interview1__title1",
      ".p-interview1__wrap1",
      ".p-support1",
      ".p-skill1__title1",
      ".p-skill1__wrap2",
    ];

    vertical.forEach(function (el) {
      gsap.from(el, {
        opacity: 0,
        y: -40,
        duration: 1.5,
        ease: "Expo.easeOut",
        scrollTrigger: {
          trigger: el,
          start: "top+=200 bottom",
        },
      });
    });
  }
}

const path = window.location.pathname;
const isRootPath = path === "/projects" || path === "/";

if (isRootPath) {
  window.addEventListener("load", () => {
    new TopAnimation();
  });
}
